export default __webpack_public_path__ + "static/14-binary-code-bfe5c24c282b1528d5218d298015d342.png";